angular.module('qkr').factory('departmentService', ($http, appConfig, $q, $uibModal, utils, outletService, merchantService, _) => {
    let currentDepartmentId = null; // TODO remove this state - do not want to maintain state in services like this

	return {

	    // TODO remove department cache - it provides little value and makes things complex
        departmentList: [],

        // TODO remove these setters and getters
        getCurrentDepId: () => currentDepartmentId,
        setCurrentDepId: (id) => {
            currentDepartmentId = id;
        },

        setSelectedDepartmentId(depId) {
            currentDepartmentId = depId;
        },

        /**
         * @deprecated Do not use this function, use loadOutletDepartments in outletService instead
         */
        getDepartments(url) {
            return $http.get(appConfig.apiUrl + 'outlet/' + url + '/departments', {withCredentials: true})
                .then(response => {
                    this.departmentList = response.data;
                    const departments = this.departmentList;
                    angular.forEach(this.departmentList, (dep) => {
                        // These are static logos based on the departments
                        if (utils.hasNoValue(dep.logo)) {
                            dep.fulllogo = '';
                        } else {
                            dep.fulllogo = utils.checkSSL('https://qkr.azureedge.net/img/mss/' + dep.logo);
                        }

                        // TODO remove this mutation + decouple from merchantService
                        // Mark department as readonly if it belongs to a different merchant (reseller model)
                        const merchantId = merchantService.merchantInfo.id;
                        if (dep.merchantId !== merchantId) {
                            dep.readOnly = true;
                        }

                        // Remove deleted prodGroups (for now server still sends them)
                        const notDeletedProdGroups = [];
                        if (dep.prodGroups) {
                            for (let i = 0; i < dep.prodGroups.length; ++i) {
                                if (!dep.prodGroups[i].deleted) {
                                    notDeletedProdGroups.push(dep.prodGroups[i]);
                                }
                            }
                        }
                        dep.prodGroups = notDeletedProdGroups;
                    });
                    return departments;
                });
        },

        /**
         * @deprecated Do not use this function, use loadOutletDepartments in outletService instead
         */
        loadDepartments() {
            if (utils.hasNoValue(this.departmentList)) {
                let url = '';
                if (outletService.outletInfo !== null) {
                    url = outletService.outletInfo.id;
                } else {
                    return outletService.refreshOutletInfo().then(() => {
                        url = outletService.outletInfo.id;
                        return this.getDepartments(url);
                    });
                }
                return this.getDepartments(url);
            } else {
                // Return the cached list (as a promise)
                const deferred = $q.defer();
                deferred.resolve(this.departmentList);
                return deferred.promise;
            }
        },

        // QKRD-3321 - If there is more than 1 menu in a department (in an AUS school) then show a prompt
        showMultipleMenusInDeptWarning() {
            const department = _.findWhere(this.departmentList, {id: currentDepartmentId});
            const isAustralianSchool = merchantService.merchantInfo
                && merchantService.merchantInfo.contactDetails
                && merchantService.merchantInfo.contactDetails.country
                && merchantService.merchantInfo.contactDetails.country.isoCode === 'AU';

            if (isAustralianSchool && department && department.prodGroups.length >= 1) {
                return $uibModal.open({
                    template: require('../templates/common/modalDialog.html'),
                    controller: 'commonModalDialogController',
                    windowClass: 'fade',
                    backdrop: 'static',
                    resolve: {
                        title() {
                            return 'Warning';
                        },
                        confirmButtonName() {
                            return 'OK';
                        },
                        confirmMsg() {
                            return 'We recommend only one Menu per Department in most cases for a better user ' +
                                'experience on Qkr. Before creating a second Menu, please contact your Qkr account ' +
                                'manager for advice.';
                        },
                        multiMsgArray() {
                            return ['Select Cancel, or OK to add a new Menu'];
                        }
                    }
                });
            } else {
                return null;
            }
        },

        moveDepartment(departmentId, departmentOrder) {
            return $http.post(appConfig.apiUrl + 'department/moveDepartment',
                {departmentId, departmentOrder}).then(rs => rs.data);
        },

        moveProductGroup(departmentId, prodGroupId, newProdGroupIndex) {
            return $http.post(appConfig.apiUrl + 'department/moveProductGroup',
                {departmentId, prodGroupId, newProdGroupIndex}).then(rs => rs.data);
        },

        showCreateMenuModal(menuName) {
            return $uibModal.open({
                template: require('../templates/menu/editMenu.html'),
                controller: 'MenuEditController',
                windowClass: 'modal-huge dragModal',
                backdrop: 'static',
                resolve: {
                    menu() {
                        const newMenu = {
                            name: menuName
                        };
                        return newMenu;
                    },
                    isNewMenu() {
                        return true;
                    },
                    isSharedMenu() {
                        return false;
                    },
                    existingMenuTypes() {
                        return [];
                    }
                }
            });
        },

        addMenuToCurrentDepartment(prodGroup) {
            const dep = {id: currentDepartmentId};

            const createCommand = {
                prodGroup: utils.idOnly(prodGroup),
                department: utils.idOnly(dep)
            };

            return $http.post(appConfig.apiUrl + 'department/addMenu', createCommand);
        },

        removeMenuFromCurrentDepartment(prodGroup) {
            const dep = {id: currentDepartmentId};

            const removeCommand = {
                prodGroup: utils.idOnly(prodGroup),
                department: utils.idOnly(dep)
            };

            return $http.post(appConfig.apiUrl + 'department/removeMenu', removeCommand);
        },

        clearDepartmentCache() {
            this.departmentList = null;
        },

        createDepartmentPost(dep) {
            return $http.post(appConfig.apiUrl + 'department/create', dep);
        },

        updateDepartmentPost(dep) {
            return $http.post(appConfig.apiUrl + 'department/update', dep);
        },

        deleteDepartmentPost(dep) {
            return $http.post(appConfig.apiUrl + 'department/delete', utils.idOnly(dep));
        },

        getPossibleResellers(departmentId) {
            return $http.get(appConfig.apiUrl + 'department/' + departmentId + '/getPossibleSupplierStoreMerchants',
                {withCredentials: true});
        },

        createShareRequest(dep, storeMerchantId, emailAddress) {
            const cmd = {
                departmentId: dep.id,
                storeMerchantId,
                emailAddress
            };
            return $http.post(appConfig.apiUrl + 'department/createSupplierPendingRequest', cmd);
        },

        getMerchantBySupplierEmail(emailSupplier) {
            const cmd = {
                emailAddress: emailSupplier
            };

            return $http.post(appConfig.apiUrl + 'department/getMerchantForEmail', cmd);
        },

        loadPendingRequests() {
            return $http.get(appConfig.apiUrl + 'department/getSupplierPendingRequests', {withCredentials: true});
        },

        addNewAttributesToDepartment(departmentList, dataResponse) {
            angular.forEach(departmentList, (dept) => {
                if (dept.sharedWith) {
                    dept.status = 'Shared';
                } else {
                    dept.status = 'Not Shared';
                }
            });

            angular.forEach(dataResponse, (data) => {
                const dept = _.find(departmentList, (department) => department.id === data.departmentId);

                if(dept) {
                    dept.status = 'Pending';
                    dept.shareRequestId = data.supplierPendingRequestId;
                    dept.sharedWith = data.storeMerchantName;
                }
            });

            return departmentList;
        },

        unshareDepartmentPost(dep) {
            return $http.post(appConfig.apiUrl + 'department/unshare', utils.idOnly(dep));
        },

        cancelShareRequestDepartmentPost(shareRequestId) {
            return $http.post(appConfig.apiUrl + 'department/cancelShareRequest', {id: shareRequestId});
        },

        // All the schools that have the Finance 1 accounting system enabled can't rename the department called Canteen
        checkIfDepartmentNameDisabled(departmentName) {
            return departmentName === 'Canteen'
                && merchantService.behaviour(merchantService.merchantInfo, 'deptEditPage.isFinance1');
        },

        acceptShare(dep) {
            return $http.post(appConfig.apiUrl + 'department/acceptShareDepartment', utils.idOnly(dep));
        }

    };
});




// WEBPACK FOOTER //
// ./src/services/department.services.js